<!-- //
svg图片加载
@auth xuyd
@date 2024-05-01
//-->
<template>
  <i v-if="icon.startsWith('el-')" :class="icon"/>
  <svg v-else :class="svgClass" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="iconName"/>
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.icon}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },
  }
}
</script>

<style scoped>
.svg-icon {
  width: 20px;
  height: 20px;
  overflow: hidden;
}

.svg {
  width: 100%;
  height: 100%;
}
</style>
